import { createContext, useContext } from "react";

import { ApigeeApps } from "./validation";

export const ApigeeContext = createContext([] as ApigeeApps);

export const useApigee = () => useContext(ApigeeContext);
